<div class="report-img-container">
    <div class="title">
        <span><strong>{{"step_type_multi_capture_count" | translate}}</strong> {{images.length}}</span>
    </div>
    <ul class="report-image-list">
        <li *ngFor="let item of images" class="report-image-list-item">
            <img class="report-image" src='{{item.ImageUrl}}' (click)="openImage(item.ImageUrl)" />
        </li>
    </ul>
</div>
